module.exports = __webpack_public_path__ + "img/sozialschnellgut_1_a.7c157dc6.jpg";